import { render, staticRenderFns } from "./ressource-not-found.vue?vue&type=template&id=5516bc3f&scoped=true&"
import script from "./ressource-not-found.vue?vue&type=script&lang=js&"
export * from "./ressource-not-found.vue?vue&type=script&lang=js&"
import style0 from "./ressource-not-found.vue?vue&type=style&index=0&id=5516bc3f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5516bc3f",
  null
  
)

export default component.exports